import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyprofileFreespaceCard',
  props: {
    currentCardId: null,
    formatId: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  formatId?: string
};



const formatData = useRirekishoFormatData()

const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

const freespace = computed({
  get: () => String(formatData.freespace ?? ''),
  set: (value: string) => {
    formatData.freespace = value
  }
})

return { __sfc: true,props, formatData, isSection, freespace }
}

})